import PropTypes from "prop-types";

import Box from "@mui/material/Box";
import TableRow from "@mui/material/TableRow";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableSortLabel from "@mui/material/TableSortLabel";
import { visuallyHidden } from "../../utility/utils/utils";

interface HeadLabel {
  id: string;
  label?: string;
  align?: "left" | "right" | "center";
}

interface CircleTableHeadProps {
  order?: any;
  orderBy?: string;
  rowCount?: number;
  headLabel?: HeadLabel[];
  numSelected?: number;
  onRequestSort?: (e?: any, p?: any) => void;
  onSelectAllClick?: (e?: any) => void;
}

export default function CircleTableHead(props: CircleTableHeadProps) {
  const {
    order,
    orderBy,
    // rowCount,
    headLabel,
    // numSelected,
    onRequestSort,
    // onSelectAllClick,
  } = props;

  const onSort = (property: any) => (event: any) => {
    if (onRequestSort) {
      onRequestSort(event, property);
    }
  };

  return (
    <TableHead>
      <TableRow>
        {headLabel?.map((headCell: any) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || "left"}
            sortDirection={orderBy === headCell.id ? order : false}
            sx={{
              width: headCell.width,
              minWidth: headCell.minWidth,
              fontSize: 15.5,
              textAlign: "center",
            }}
          >
            <TableSortLabel
              hideSortIcon
              active={orderBy === headCell.id}
              direction={orderBy === headCell.id ? order : "asc"}
              onClick={onSort(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box sx={{ ...visuallyHidden }}>
                  {order === "desc" ? "sorted descending" : "sorted ascending"}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

CircleTableHead.propTypes = {
  order: PropTypes.oneOf(["asc", "desc"]),
  orderBy: PropTypes.any,
  rowCount: PropTypes.number,
  headLabel: PropTypes.array,
  numSelected: PropTypes.number,
  onRequestSort: PropTypes.func,
  onSelectAllClick: PropTypes.func,
};
